export default __webpack_public_path__ + "static/media/mmhdWhiteT.d204bda7.png";